import { Injectable } from "@angular/core"
import { VcoOrderSummaryPayload } from "@app/features/purchasingCoOp/orders/orderFeatureService/orderFeature.service.types"
import { Subject } from "rxjs"

@Injectable({ providedIn: 'root' }) export class ServiceBusService {
    readonly refreshContractVehicleLimitSummariesByContractAndMemberId = new Subject<{ contractId: string, memberId: string }>()
    readonly fullRefresh = new Subject<void>()
    readonly refreshContract = new Subject<string>()
    readonly refreshOrderAndVehicleSummariesByOrderId = new Subject<string>()
    readonly refreshVehicleSummaryForOrder = new Subject<VcoOrderSummaryPayload>()
}